import { render, staticRenderFns } from "./jiagong.vue?vue&type=template&id=3b6d70d6&scoped=true&"
import script from "./jiagong.vue?vue&type=script&lang=js&"
export * from "./jiagong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d70d6",
  null
  
)

export default component.exports